import React from "react";
import clsx from "clsx";

import useBalancedText from "./utils/useBalancedText";
import ContainerBleed from "@app/components/ContainerBleed";

import styles from "./BigBlockquote.module.css";

export default function BigBlockquote({
  className,
  children,
  deadline,
  ...rest
}) {
  const textRef = React.useRef();

  useBalancedText(textRef);

  return (
    <ContainerBleed
      tag="blockquote"
      className={clsx(styles.root, className)}
      {...rest}
    >
      <div className={styles.content}>
        <div ref={textRef}>{children}</div>
      </div>
    </ContainerBleed>
  );
}
